export enum RetailMatchGeographyOption {
  CensusRegion = 3, // USA
  DMA = 6,
  State = 7,
  Region = 9, // Canada
  National = 100,
}
